import classnames from "classnames";
import { inject } from "mobx-react";
import React from "react";
import type { Store } from "../../../client/stores";
import "./IHRPlayerBar.style.scss";

export interface IHRPlayerBarProps {
    store?: Store;
}

const getWidgetIframeUrl = (
    nationalUrl: string,
    streamId: string | number,
    streamType: string,
    theme = "light",
    campId: string,
    sc: string,
    pName: string,
) => {
    return `${nationalUrl}/${streamType}/${streamId}/?embed=true&sc=${sc}&campid=${campId}&pname=${pName}&theme=${theme}&ihrnetwork=true`;
};

export const IHRPlayerBar = inject("store")(({ store }: IHRPlayerBarProps) => {
    const designConfig = store?.site.config.sections?.design;
    const campid = "b";
    const sc = "inferno";
    const pname = store?.site.index.slug.toUpperCase() || "";

    if (
        !designConfig ||
        !designConfig.ihr_embed_player_bar_switch ||
        !designConfig.ihr_embed_player_bar_stream_id ||
        !designConfig.ihr_embed_player_bar_stream_type ||
        !designConfig.ihr_embed_player_bar_stream_theme
    ) {
        return null;
    }

    const url = getWidgetIframeUrl(
        store?.env.NATIONAL_SITE_URL || "",
        designConfig.ihr_embed_player_bar_stream_id,
        designConfig.ihr_embed_player_bar_stream_type,
        designConfig.ihr_embed_player_bar_stream_theme,
        campid,
        sc,
        pname,
    );

    const classes = classnames("ihr-player-bar", {
        "ihr-has-cta": designConfig.ihr_embed_player_bar_cta,
    });

    return (
        <React.Fragment>
            <div className={classes}>
                <div className="ihr-player-bar-content">
                    {designConfig.ihr_embed_player_bar_cta ? (
                        <div id="ihr-player-cta">{designConfig.ihr_embed_player_bar_cta}</div>
                    ) : null}
                    <iframe
                        title="Listen on iHeartRadio"
                        id="ihr-player-bar-frame"
                        allow="autoplay"
                        src={url}
                        scrolling="no"
                        frameBorder={0}
                    />
                </div>
            </div>
        </React.Fragment>
    );
});

export default IHRPlayerBar;
